var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeWidth: 1.5,
  d: "M20.93 7.584 17.8 20.201a1 1 0 0 1-1.212.73L3.97 17.799a1 1 0 0 1-.73-1.211L6.372 3.97a1 1 0 0 1 1.212-.73L20.2 6.373a1 1 0 0 1 .73 1.211ZM4.928 9.794l6.56 6.78m1.203-4.854 7.758-2.195m-6.071-4.597-3.614 14.558"
})));
export default SvgIconSector;